module.exports = __webpack_public_path__ + "slide9.f24635a936d101590e67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide9.jpg
// module id = ./src/assets/images/private/home/slide9.jpg
// module chunks = main